import { Navigate } from "react-router-dom";
import { canSeeReactivation } from "@utils/access";

/** /reactivation is for clinics that can place outbound calls; admins always
 * pass. The backend re-checks every request. */
const ReactivationRoute = ({ children }) => (canSeeReactivation() ? children : <Navigate to="/" replace />);
export default ReactivationRoute;
